import { Offcanvas } from "bootstrap";

export default class NavigationMenu {
    private headerElement: HTMLElement;
    private megaMenuToggleBtn: HTMLButtonElement;
    private mobileNavContainer: HTMLUListElement;
    private topLevelMenu: HTMLUListElement;
    private searchButton: HTMLButtonElement;
    private searchFormWrapper: HTMLElement;
    private megaMenuContainer: HTMLElement;
    private onlineServicesOffcanvasEl: HTMLElement;
    private overlayElement: HTMLElement;
    private skipButtons: HTMLAnchorElement[];
    private lastFocusableElement: HTMLElement;

    private currentY = 0;
    parentMenuItem: HTMLElement;
    private showTimeout: number;
    private hideTimeout: number;
    private activeSubmenu: HTMLElement;
    constructor() {
        this.initDOMElement();
        this.addEventListener();
    }

    private initDOMElement() {
        this.headerElement = document.querySelector('.navbar');
        this.megaMenuToggleBtn = document.querySelector<HTMLButtonElement>(".menu-toggle-btn");
        this.megaMenuContainer = document.getElementById('mega-menu') as HTMLElement;
        this.overlayElement = document.querySelector(".overlay") as HTMLElement;

        this.onlineServicesOffcanvasEl = document.getElementById('online-services');
        this.mobileNavContainer = document.querySelector(".mega-menu .nav-item-wrapper");
        this.topLevelMenu = this.mobileNavContainer.querySelector(".nav__list");
        this.skipButtons = Array.from(this.headerElement.querySelectorAll<HTMLAnchorElement>("a.skip"));

        this.searchButton = document.querySelector(".search-btn");
        this.searchFormWrapper = document.getElementById("mobile-search");
    }

    private addEventListener() {
        /* Desktop Mega menu */
        const allOffcanvasElements = document.querySelectorAll<HTMLElement>(".offcanvas");
        const focusableElements = Array.from(this.megaMenuContainer.querySelectorAll<HTMLElement>("a, button"));

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        allOffcanvasElements?.forEach(el => {
            const offcanvas = Offcanvas.getOrCreateInstance(el);
            if (offcanvas) {
                offcanvas.hide();
            }

            el.addEventListener("shown.bs.offcanvas", () => {
                this.hideMegaMenu();
                document.body.style.overflow = 'hidden';
            });
        })

        this.megaMenuToggleBtn.addEventListener('click', () => {
            const isOpen = this.megaMenuContainer.classList.contains('show');

            if (isOpen) {
                this.hideMegaMenu();
            } else {
                this.showMegaMenu(firstElement);
            }
        })

        this.megaMenuToggleBtn.addEventListener('keydown', (e: KeyboardEvent) => {
            let isOpen = this.megaMenuContainer.classList.contains('show');

            if (e.key === "Tab" && e.shiftKey) {
                if (!isOpen) return;

                if (document.activeElement === this.megaMenuToggleBtn) {
                    e.preventDefault();
                    lastElement.focus();
                    console.log(lastElement);
                }
            }
        })

        this.megaMenuContainer.addEventListener('keydown', (e: KeyboardEvent) => {
            let isOpen = this.megaMenuContainer.classList.contains('show');

            if (e.key === "Tab") {
                if (!isOpen) return;

                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        this.megaMenuToggleBtn.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        this.megaMenuToggleBtn.focus();
                    }
                }
            } else if (e.key === "Escape") {
                // Close on Escape
                this.hideMegaMenu();
                this.megaMenuToggleBtn.focus();
                isOpen = false;
            }
        });

        this.overlayElement.addEventListener("click", () => {
            this.overlayElement.classList.remove("show");
            this.hideMegaMenu();
        })

        this.attachEventListenerToArrowButtons(this.mobileNavContainer);

        /* Search */
        const searchIcon = this.searchButton.querySelector('.dot-icon');

        this.searchFormWrapper.addEventListener('show.bs.offcanvas', () => {
            searchIcon.classList.remove('dot-stroke-search');
            searchIcon.classList.add('dot-stroke-close');
        })

        this.searchFormWrapper.addEventListener('hide.bs.offcanvas', () => {
            searchIcon.classList.remove('dot-stroke-close');
            searchIcon.classList.add('dot-stroke-search');
        })

        /* Online Services Menu */
        const onlineServicesMenuToggleBtns = document.querySelectorAll("button[data-bs-target='#online-services']") as NodeListOf<HTMLButtonElement>;

        this.onlineServicesOffcanvasEl.addEventListener("shown.bs.offcanvas", () => {
            onlineServicesMenuToggleBtns.forEach(btn => {
                btn.setAttribute("aria-expanded", "true");
            });
        });

        this.onlineServicesOffcanvasEl.addEventListener("hide.bs.offcanvas", () => {
            onlineServicesMenuToggleBtns.forEach(btn => {
                btn.setAttribute("aria-expanded", "false");
            });
        });
    };

    private attachEventListenerToArrowButtons(menuItem: HTMLElement) {
        const navArrows = menuItem.querySelectorAll('.nav--arrow') as NodeListOf<HTMLButtonElement>;
        const backBtns = menuItem.querySelectorAll('.back--btn') as NodeListOf<HTMLButtonElement>;
        const lastItemArray = Array.from(this.topLevelMenu.children).filter(child => !child.classList.contains('main-nav__items'));
        const lastChildInLevel1 = lastItemArray[lastItemArray.length - 1] as HTMLElement;

        navArrows.forEach((arrow) => {
            const parent = arrow.parentElement;
            let isLevel2 = menuItem.classList.contains('nav__level-1');
            const submenu = arrow.nextElementSibling as HTMLUListElement;
            isLevel2 = arrow.nextElementSibling.classList.contains('nav__level-2');
            const allChildItems = isLevel2 ? menuItem.querySelectorAll('.nav__level-2') : menuItem.querySelectorAll('.nav__level-1');

            arrow.addEventListener('click', () => {
                if (window.innerWidth > 992) {

                    if (parent === lastChildInLevel1 || (lastChildInLevel1.contains(arrow) && parent.parentElement.lastElementChild === parent)) {
                        this.initFocusTrap(submenu, true, isLevel2 ? 2 : 3)
                    }
                    allChildItems.forEach(item => {
                        const arrowIcon = item.previousElementSibling;
                        if (arrowIcon != arrow) {
                            arrowIcon.setAttribute('aria-expanded', 'false');
                        }
                    });
                    this.showSubmenu(submenu, arrow);
                } else {
                    this.showNestedMenu(parent, isLevel2);
                }
            });

            if (window.innerWidth > 992) {
                parent.addEventListener('mouseenter', () => {
                    clearTimeout(this.hideTimeout)

                    this.showTimeout = window.setTimeout(() => {
                        allChildItems.forEach(item => {
                            const arrow = item.previousElementSibling
                            arrow.setAttribute('aria-expanded', 'false');
                            item.classList.remove('active')
                        });
                        this.showSubmenu(submenu, arrow);

                    }, 300);
                });

                parent.addEventListener('mouseleave', () => {
                    clearTimeout(this.showTimeout)

                    this.hideTimeout = window.setTimeout(() => {
                        if (this.activeSubmenu) {
                            arrow.setAttribute('aria-expanded', 'false');
                            submenu.classList.remove('active');
                            this.activeSubmenu = null;
                        }

                        allChildItems.forEach(item => {
                            const arrow = item.previousElementSibling
                            arrow.setAttribute('aria-expanded', 'false');
                            item.classList.remove('active')
                        });
                    }, 300);
                });

                parent.addEventListener('focusout', (e: FocusEvent) => {
                    const target = e.relatedTarget as HTMLElement;

                    if (target && !parent.contains(target)) {
                        submenu.classList.remove('show');
                        arrow.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        });

        backBtns.forEach(btn => {
            const parent = menuItem;
            const isLevel2 = menuItem.classList.contains('nav__level-2');

            btn.addEventListener('click', () => {
                this.hideNestedMenu(parent, isLevel2);

                setTimeout(() => {
                    if (this.parentMenuItem) {
                        this.parentMenuItem.focus();
                        this.parentMenuItem = null;
                    }
                }, 200);
            });
        });
    }

    showMegaMenu(firstElement: HTMLElement) {
        const activeOffcanvasElement = document.querySelector(".offcanvas.show");
        const allFocusableElementsExceptToggle = document.querySelectorAll("main, .navbar-container a, .navbar-container button:not(.menu-toggle-btn), .navbar-container .search-input, .navbar-container .search-input__button") as NodeListOf<HTMLElement>;

        if (activeOffcanvasElement) {
            Offcanvas.getOrCreateInstance(activeOffcanvasElement).hide();
        }

        allFocusableElementsExceptToggle.forEach(el => el.tabIndex = -1)
        this.skipButtons.forEach(button => button.tabIndex = -1);
        this.megaMenuToggleBtn.setAttribute('aria-expanded', 'true');

        document.body.style.overflow = 'hidden';

        setTimeout(() => {
            this.megaMenuToggleBtn.classList.add('show');
            this.megaMenuContainer.classList.add('showing');
            this.overlayElement.classList.add('show');

            setTimeout(() => {
                this.megaMenuContainer.classList.remove('showing');
                this.megaMenuContainer.classList.add('show');

                if (window.innerWidth > 992) {
                    this.initFocusTrap(this.megaMenuContainer, true);
                }
            }, 50);
        }, 1);

        firstElement.focus();
    }

    hideMegaMenu() {
        const headerOtherButtons = document.querySelectorAll(".navbar-container a, .navbar-container button:not(.menu-toggle-btn)") as NodeListOf<HTMLElement>;
        const allFocusableElementsExceptToggle = document.querySelectorAll("main, .navbar-container a, .navbar-container button:not(.menu-toggle-btn), .navbar-container .search-input, .navbar-container .search-input__button") as NodeListOf<HTMLElement>;

        allFocusableElementsExceptToggle.forEach(el => el.tabIndex = 0)
        this.skipButtons.forEach(button => button.tabIndex = 0);
        this.megaMenuToggleBtn.setAttribute('aria-expanded', 'false');

        if (window.innerWidth > 992) {
            this.headerElement.classList.add('sticky');
        } else {
            document.body.style.overflow = 'auto';
        }

        setTimeout(() => {
            this.megaMenuToggleBtn.classList.remove('show');
            this.megaMenuContainer.classList.add('hiding');
            this.overlayElement.classList.remove('show');

            headerOtherButtons.forEach(btn => btn.tabIndex = 0)

            setTimeout(() => {
                this.megaMenuContainer.classList.remove('hiding');
                this.megaMenuContainer.classList.remove('show');
            }, 50);
        }, 50);
    }


    private showSubmenu(submenu: HTMLElement, arrow: HTMLElement) {
        const parent = arrow.parentElement;
        arrow.setAttribute('aria-expanded', 'true');
        submenu.classList.add('active');
        this.activeSubmenu = submenu;

        if (submenu && submenu.classList.contains('active')) {
            const viewportHeight = window.innerHeight;
            const headerHeight = document.querySelector('header').clientHeight;
            const maxHeight = viewportHeight - headerHeight;
            const offsetHeight = parent.getBoundingClientRect().top;

            if (submenu.offsetHeight > window.innerHeight - parent.getBoundingClientRect().top) {
                if (submenu.scrollHeight >= maxHeight) {
                    submenu.style.paddingTop = '1.5rem';
                    submenu.style.top = `-${offsetHeight - headerHeight}px`;
                    this.createArrows(submenu);
                    this.handleScrollWithTranslate(submenu);
                } else {
                    const submenuBottom = offsetHeight + submenu.scrollHeight;
                    const overflowAmount = submenuBottom - viewportHeight;
                    const translateUp = overflowAmount;

                    submenu.style.top = `-${translateUp}px`;
                }
            }
        }
    }

    private showNestedMenu(parent: HTMLElement, isLevel2: boolean) {
        this.parentMenuItem = parent;

        if (window.innerWidth < 992) {
            const existingLevel1 = this.mobileNavContainer.querySelector('.nav__level--1.hide');

            if (existingLevel1) {
                this.mobileNavContainer.removeChild(existingLevel1);
            }

            const nestedMenuClone = parent.querySelector('.slide').cloneNode(true) as HTMLElement;

            this.attachEventListenerToArrowButtons(nestedMenuClone);
            this.mobileNavContainer.appendChild(nestedMenuClone);
            nestedMenuClone.classList.add('show');
            this.topLevelMenu.classList.add('hide');
            nestedMenuClone.style.zIndex = "2";

            if (isLevel2) {
                const level1Menu = this.mobileNavContainer.querySelector('.nav__level-1.show') as HTMLElement;
                level1Menu.classList.remove('show');

                this.initFocusTrap(nestedMenuClone, false, 2);
            } else {
                this.initFocusTrap(nestedMenuClone);
            }
        }
    }

    private hideNestedMenu(parent: HTMLElement, isLevel2: boolean) {
        if (isLevel2) {
            const level2Menu = this.mobileNavContainer.querySelector('.nav__level-2.show');
            const level1Menu = level2Menu.previousElementSibling as HTMLElement;
            level1Menu.classList.add('show');
            level2Menu.remove();
            this.initFocusTrap(level1Menu);
        } else {
            parent.remove();
            this.topLevelMenu.classList.remove('hide');
            this.initFocusTrap(this.topLevelMenu);
        }
    }

    private initFocusTrap(container: HTMLElement, isDesktopMenu = false, depth = 1) {
        let focusableElements = this.getInitialFocusableElements(container, isDesktopMenu, depth);
        this.lastFocusableElement = focusableElements[focusableElements.length - 1]

        container.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key === "Tab" && !e.shiftKey) {
                const activeElement = document.activeElement as HTMLElement;

                if (activeElement === this.lastFocusableElement) {
                    e.preventDefault();
                    this.megaMenuToggleBtn.focus();
                }
            }
        })
        focusableElements[0]?.focus()
    }

    private getInitialFocusableElements(container: HTMLElement, isDesktopMenu?: boolean, depth?: number): HTMLElement[] {
        let focusableElements = Array.from(container.querySelectorAll('a, button'))

        if (isDesktopMenu) {
            const selector = depth === 1 ? ".nav__list > .nav-item > a, .nav__list > .nav-item > button" : "& > .child-list > .nav-item > a, & > .child-list > .nav-item > button[aria-expanded='false']";
            focusableElements = Array.from(container.querySelectorAll(selector));
        }
        if (depth != 2) {
            focusableElements = focusableElements.filter(el => !el.closest('.nav__level-2'));
        }

        return focusableElements as HTMLElement[];
    }

    private createArrows(submenu: HTMLElement) {
        const arrowUp: HTMLButtonElement = submenu.querySelector('.scroll-up') ?? document.createElement('button');
        arrowUp.classList.add('scroll-up');
        arrowUp.classList.add('scroll-arrow');
        arrowUp.setAttribute('aria-label', 'move up');
        arrowUp.innerHTML = '<span class="dot-icon dot-stroke-dropdown-up dot-icon-lg" aria-hidden="true"></span>';

        const arrowDown: HTMLButtonElement = submenu.querySelector('.scroll-down') ?? document.createElement('button');
        arrowDown.classList.add('scroll-down');
        arrowDown.classList.add('scroll-arrow');
        arrowDown.setAttribute('aria-label', 'move down');
        arrowDown.innerHTML = '<span class="dot-icon dot-stroke-dropdown-down dot-icon-lg" aria-hidden="true"></span>';
        arrowDown.classList.add('show');
        arrowDown.style.top = window.innerHeight - this.headerElement.clientHeight - 24 + 'px';

        submenu.appendChild(arrowUp);
        submenu.appendChild(arrowDown);

        arrowUp.addEventListener('mouseenter', () => this.handleMouseEnter(submenu, arrowDown, arrowUp, 'up'));
        arrowDown.addEventListener('mouseenter', () => this.handleMouseEnter(submenu, arrowDown, arrowUp, 'down'));
    }

    private handleMouseEnter = (submenu: HTMLElement, downArrow: HTMLButtonElement, upArrow: HTMLButtonElement, direction: 'up' | 'down') => {
        let scrollInterval: number | null = null; // Properly initialize scrollInterval
        const ul = submenu.querySelector('& > ul') as HTMLUListElement;
        const scrollStep = 5;
        const ulHeight = ul.clientHeight + 24;
        const headerHeight = document.querySelector('header')?.clientHeight || 0;
        const viewportHeight = window.innerHeight;
        const availableHeight = viewportHeight - headerHeight;
        const scrollContent = () => {
            if (direction === 'down') {
                this.currentY += scrollStep;
                if (this.currentY >= ulHeight - availableHeight) {
                    this.currentY = ulHeight - availableHeight;
                    downArrow.classList.remove('show');
                    clearInterval(scrollInterval!);
                } else {
                    downArrow.classList.add('show');
                    upArrow.classList.add('show');
                }
            } else {
                this.currentY -= scrollStep;
                if (this.currentY <= 0) {
                    this.currentY = 0;
                    upArrow.classList.remove('show');
                    clearInterval(scrollInterval!);
                } else {
                    downArrow.classList.add('show');
                    upArrow.classList.add('show');
                }
            }
            ul.style.transform = `translate3d(0, ${-this.currentY}px, 0)`;
        };

        // Start scrolling when mouse enters
        scrollInterval = window.setInterval(scrollContent, 50);

        // Stop scrolling on mouse leave
        const handleMouseLeave = () => {
            if (scrollInterval !== null) {
                clearInterval(scrollInterval);
                scrollInterval = null;
            }
        };

        downArrow.addEventListener('mouseleave', handleMouseLeave);
        upArrow.addEventListener('mouseleave', handleMouseLeave);
    };

    private handleScrollWithTranslate(submenu: HTMLElement) {
        const ul = submenu.querySelector('& > ul') as HTMLUListElement;
        const viewportHeight = window.innerHeight;
        const headerHeight = document.querySelector('header')?.clientHeight || 0;
        const availableHeight = viewportHeight - headerHeight;
        const upArrow = this.megaMenuContainer.querySelector(".scroll-up") as HTMLButtonElement;
        const downArrow = this.megaMenuContainer.querySelector(".scroll-down") as HTMLButtonElement;
        const wheelHandler = (event: WheelEvent) => {
            event.preventDefault();

            const deltaY = event.deltaY;
            this.currentY += deltaY;

            const ulHeight = ul.clientHeight + 24;
            if (deltaY > 0) {
                upArrow.classList.add('show');
            } else {
                downArrow.classList.add('show');
            }
            if (deltaY > 0 && this.currentY > ulHeight - availableHeight) {
                this.currentY = ulHeight - availableHeight;
                downArrow.classList.remove('show');
            }

            if (deltaY < 0 && this.currentY < 0) {
                this.currentY = 0;
                upArrow.classList.remove('show');
            }

            ul.style.transform = `translate3d(0, ${-this.currentY}px, 0)`;
        };
        submenu.addEventListener('wheel', wheelHandler);
        ul.addEventListener('keydown', (e) => {
            const key = e.key
            if (key === 'Tab' || key === 'ArrowDown' || key === 'ArrowUp') {
                requestAnimationFrame(() => {
                    const focused = document.activeElement as HTMLElement;

                    if (!ul.contains(focused)) return;

                    const focusedRect = focused.getBoundingClientRect();
                    const ulRect = ul.getBoundingClientRect();

                    const topOverflow = focusedRect.top < upArrow.offsetTop;
                    const bottomOverflow = focusedRect.bottom > downArrow.offsetTop;

                    if (topOverflow) {
                        // Scroll up to reveal the item
                        this.currentY = Math.max(0, this.currentY - (ulRect.top - focusedRect.top + 8));
                        downArrow.classList.add('show');
                        if (this.currentY <= 0) upArrow.classList.remove('show');
                    } else if (bottomOverflow) {
                        // Scroll down to reveal the item
                        const delta = focusedRect.bottom - ulRect.bottom + 8;
                        this.currentY = Math.min(ul.scrollHeight - availableHeight, this.currentY + delta);
                        upArrow.classList.add('show');
                        if (this.currentY >= ul.scrollHeight - availableHeight) downArrow.classList.remove('show');
                    }

                    ul.style.transform = `translate3d(0, ${-this.currentY}px, 0)`;
                });
            }

            // Optional: loop back to toggle if on last focusable item
            if (key === 'Tab' && !e.shiftKey) {
                const activeElement = document.activeElement as HTMLElement;
                if (activeElement === this.lastFocusableElement) {
                    e.preventDefault();
                    this.megaMenuToggleBtn.focus();
                }
            }
        })
    }

}
